module.exports = __webpack_public_path__ + "static/media/game-display-1@2x.6101d9fb.png";